module.exports = __webpack_public_path__ + "img/s-1.8c1fa80e.png";